import type { AavoObjectRef } from "src/api/generated/common/aavoObject/aavoObjectRef.ts";
import { filterNulls } from "src/utils/arrayUtils.ts";

export interface ShopOrderDocumentRefSource {
	shopOrderId: number;
	catalogPartRevisionId?: number | null;
	partConfigurationId?: number | null;
	customerOrderId?: number | null;
	customerOrderLineId?: number | null;
	sourceProjectActivityMaterialParentMaterialId?: number | null;
	sourceProjectActivityMaterialId?: number | null;
}

export interface ShopOrderDocumentRefOptions {
	includeCustomerOrder?: boolean;
}

export function getShopOrderDocumentObjectRefs(
	shopOrder: ShopOrderDocumentRefSource,
	options: ShopOrderDocumentRefOptions = {},
): AavoObjectRef[] {
	const { includeCustomerOrder = true } = options;
	const showRevisionDocuments = shopOrder.partConfigurationId == null;

	return filterNulls([
		{ objectType: "SHOP_ORDER", objectId: shopOrder.shopOrderId },
		showRevisionDocuments && shopOrder.catalogPartRevisionId != null ?
			{ objectType: "CATALOG_PART_REVISION", objectId: shopOrder.catalogPartRevisionId }
		:	null,
		shopOrder.partConfigurationId != null ?
			{ objectType: "PART_CONFIGURATION", objectId: shopOrder.partConfigurationId }
		:	null,
		includeCustomerOrder && shopOrder.customerOrderId != null ?
			{ objectType: "CUSTOMER_ORDER", objectId: shopOrder.customerOrderId }
		:	null,
		shopOrder.customerOrderLineId != null ?
			{ objectType: "CUSTOMER_ORDER_LINE", objectId: shopOrder.customerOrderLineId }
		:	null,
		shopOrder.sourceProjectActivityMaterialParentMaterialId != null ?
			{
				objectType: "PROJECT_ACTIVITY_MATERIAL",
				objectId: shopOrder.sourceProjectActivityMaterialParentMaterialId,
			}
		:	null,
		shopOrder.sourceProjectActivityMaterialId != null ?
			{ objectType: "PROJECT_ACTIVITY_MATERIAL", objectId: shopOrder.sourceProjectActivityMaterialId }
		:	null,
	]);
}
